<template>

<div class="dropdown" :data-size="size" :data-align="align" :data-theme="theme" :class="{'is-scroll': isScroll}" v-propagation>

    <div class="dropdown-item" 
        v-for="option in optionsFinal" 
        :key="option.value" 
        v-on:click="onClick(option.value)"
        :class="{'has-colour': option.colour}"
    >

        <div class="dropdown-item-colour" v-if="option.colour" :style="{backgroundColor: option.colour}" />

        <div class="dropdown-item-text">

            <span class="dropdown-item-subtext" v-if="option.subtext">{{ option.subtext }} / </span>{{ option.text }}

        </div>

    </div>
	
</div>

</template>

<script>

export default {

    props: ['options', 'isScroll', 'exclude', 'search', 'size', 'theme', 'align'],

    computed: {

        optionsFinal: function() {

            if (!this.search && !this.exclude) return this.options

            var options = this.options

            if (this.exclude) {

                options = this.$_.filter(options, function(option) {

                    return !this.$_.contains(this.exclude, option.value)

                }.bind(this))

            }

            if (this.search) {

                var term = this.search.trim().toLowerCase()

                options = options.filter(opt =>
                    opt.text.toLowerCase().includes(term) ||
                    opt.value.toLowerCase().includes(term)
                )
                
            }

            return options

        }

    },

    methods: {

        onClick: function(value) {

            this.$emit('change', value)

        }

    }

}

</script>

<style scoped>

.dropdown {
    position: absolute;
    z-index: 100;
    width: 100%;
    min-width: 120px;
    left: 50%;
    top: calc(100% + 4px);
    transform: translateX(-50%);
    max-width: 300px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    user-select: none;
}

.dropdown.is-scroll {
    max-height: 240px;
    overflow: auto;
    border-radius: 10px;
}

.dropdown[data-theme="set"].is-scroll {
    border-radius: 4px;
}

.dropdown[data-align="left"] {
   transform: none;
   left: 0px;
   width: auto;
   white-space: nowrap;
}

.dropdown[data-size="small"] {
    padding: 4px 0px;
}

.dropdown:after {
	content: ' ';
	position: absolute;
	top: -6px;
	left: 50%;
    margin-left: -6px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 6px 6px 6px;
	border-color: transparent transparent #fff transparent;
}

.dropdown[data-align="left"]:after {
   left: 20px;
}

.dropdown-item {
    color: #082534;
    font-weight: 400;
    cursor: pointer;
    line-height: 16px;
    text-align: center;
    font-size: 14px;
    padding: 8px 10px;
    border-bottom: 1px solid #ddd;
    background-color: #fff;
}

.dropdown-item.has-colour {
    display: grid;
    grid-template-columns: 16px 1fr;
    grid-gap: 10px;
}

.dropdown[data-theme="set"] .dropdown-item {
    text-align: left;
}

.dropdown[data-align="left"] .dropdown-item {
    text-align: left;
}

.dropdown-item:first-child {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.dropdown[data-theme="set"] .dropdown-item:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.dropdown-item:last-child {
    border-bottom: 0px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

.dropdown[data-theme="set"] .dropdown-item:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.dropdown[data-size="small"] .dropdown-item {
    line-height: 16px;
    font-size: 12px;
    padding: 2px 4px;
}

.dropdown-item:hover {
    background-color: #f7f7f7;
}

.dropdown-item-colour {
    width: 16px;
    height: 16px;
    border-radius: 4px;
}

.dropdown-item-subtext {
    color: #666;
}

</style>
